import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
  borderColor: string;
};
export const LineDashed = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(13);
  let backgroundColor;
  let borderColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      borderColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = borderColor;
    $[3] = props;
  } else {
    backgroundColor = $[1];
    borderColor = $[2];
    props = $[3];
  }
  let t1;
  let t2;
  if ($[4] !== backgroundColor || $[5] !== borderColor) {
    t1 = <rect x="4.5" y="10.5" width="6.5" height="3" rx="1.5" fill={backgroundColor} stroke={borderColor} />;
    t2 = <rect x="13" y="10.5" width="6.5" height="3" rx="1.5" fill={backgroundColor} stroke={borderColor} />;
    $[4] = backgroundColor;
    $[5] = borderColor;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== ref || $[10] !== t1 || $[11] !== t2) {
    t3 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}{t2}</svg>;
    $[8] = props;
    $[9] = ref;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
});